var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDowntrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.359,
    height: 7.534,
    viewBox: "0 0 11.359 7.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trending_up_FILL0_wght400_GRAD0_opsz24",
    d: "M9.992,6.447l.752-.752-3.975-4L4.62,3.841,1.827,1.074h1.4V0H0V3.223H1.074v-1.4L4.62,5.372,6.769,3.223Z",
    transform: "matrix(-0.995, -0.105, 0.105, -0.995, 10.685, 7.534)",
    fill: "#e30000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowntrend);
export default __webpack_public_path__ + "static/media/downtrend.02b12133a956c22da03785c2d1bfb680.svg";
export { ForwardRef as ReactComponent };